import { all, fork, takeEvery } from 'redux-saga/effects';
import { types } from './reducer';
import pagination from '@iso/lib/helpers/pagination';
import PromotionService from '@iso/services/PromotionService/PromotionService';

function* watchFetchPromotionDurationList() {
    yield takeEvery(
        types.REQUEST_FETCH_PROMOTION_DURATION_LIST,
        pagination('promotionDurationList').saga(PromotionService),
    );
}

function* paginationSaga() {
    yield all([
        fork(watchFetchPromotionDurationList),
    ]);
}

export default paginationSaga;